import { useTheme } from '@automata/mui-theme';
import { BrushHandleRenderProps } from '@visx/brush/lib/BrushHandle';
import { Group } from '@visx/group';
import { SVGProps } from 'react';

export type Props = BrushHandleRenderProps;

const BrushHandle = ({
  x,
  y,
  width,
  className,
  isBrushActive,
}: Props): JSX.Element | null => {
  const theme = useTheme();

  if (!isBrushActive) return null;

  const commonCircle: SVGProps<SVGCircleElement> = {
    fill: theme.palette.grey[300],
    r: 1.25,
    pointerEvents: 'none',
  };

  const height = 25;
  const cxMultipler = 2.2;
  const heightOffset = 4;

  const isTopHandle = className.includes('top');

  return (
    <Group
      data-testid={isTopHandle ? 'brush-handle-top' : 'brush-handle-bottom'}
      top={y}
      left={x}
    >
      <rect
        width={Math.max(width, 0)}
        height={Math.max(height, 0)}
        rx={3}
        className={className}
        fill={theme.palette.grey[700]}
        cursor="row-resize"
      />
      <Group left={width / 2}>
        <circle
          {...commonCircle}
          cx={cxMultipler * -1}
          cy={height / 2 - heightOffset}
        />
        <circle {...commonCircle} cx={cxMultipler * -1} cy={height / 2} />
        <circle
          {...commonCircle}
          cx={cxMultipler * -1}
          cy={height / 2 + heightOffset}
        />
        <circle
          {...commonCircle}
          cx={cxMultipler}
          cy={height / 2 - heightOffset}
        />
        <circle {...commonCircle} cx={cxMultipler} cy={height / 2} />
        <circle
          {...commonCircle}
          cx={cxMultipler}
          cy={height / 2 + heightOffset}
        />
      </Group>
    </Group>
  );
};

export default BrushHandle;
